import { html } from 'lit/html.js'
import copyIcon from 'url:view-base/type-icon/copy.svg'
// import textico from 'url:view-base/type-icon/file-text-o.svg'
import textico from 'url:view-base/type-icon/link.svg'

import chevronDown from 'url:view-base/type-icon/chevron-down.svg'
import chevronUp from 'url:view-base/type-icon/chevron-up.svg'
import 'view-base/unit-svg'

// --------------------
// Icon Copy
// --------------------
export const copy = ( id ) => html `
  <unit-svg id="${id}" class="copy" .state=${{
     src: copyIcon, cursor: "pointer", fill: "#6CBCFF"
   }}></unit-svg>`

// --------------------
// Icon Up
// --------------------
const style = "padding-left:.25rem;padding-bottom:.25rem"
export const down = ( id = "abstract" ) => html `
  <unit-svg style="${style}" class="hash" data-hash="#${id}" .state=${{
    src: chevronDown, cursor: "pointer", fill: "#6CBCFF"
  }}></unit-svg>`

export const up = ( id = "abstract" ) => html `
  <unit-svg style="${style}" class="hash" data-hash="#${id}" .state=${{
    src: chevronUp, cursor: "pointer", fill: "#6CBCFF"
  }}></unit-svg>`

// --------------------
// Icon Hub Link
// --------------------
export const hub = ( link ) => html `
  <a href="//epha.health/${link}/" style="display:none;">info</a>
  <unit-svg class="hub" data-link="//epha.health/${link}/" .state=${{
    src: textico, cursor: "pointer", fill: "#6CBCFF"
  }}></unit-svg>`